export default {
  isAdminView(state, getters, rootState, rootGetters) {
    if (!rootGetters['teams/loaded']) return false;
    return rootGetters['users/isAdmin'] && !rootGetters['teams/currentTeam'];
  },
  kpiCards(state) {
    const s = state.summary || {};
    return [
      { key: 'schools', value: s.totalSchools ?? 0, label: 'Schools' },
      { key: 'teams', value: s.totalTeams ?? 0, label: 'Teams' },
      { key: 'athletes', value: s.totalAthletes ?? 0, label: 'Students' },
    ];
  },
  activeFilterCount(state) {
    const f = state.studentFilter;
    return [
      !!f.gender,
      !!f.sports?.length,
      !!f.graduationYears?.length,
      !!f.levels?.length,
      f.minTeamsCount != null,
    ].filter(Boolean).length;
  },
};
